export enum OfferViewLayouts {
  List = 'list',
  Tab = 'tab',
}
